export default __webpack_public_path__ + "static/media/new_family_img.776c6c85.jpg";